import { WorkloadFilterLabelValue } from '@cast/types';

import { makeSearchBoxCriteria, Criterion } from '@cast/shared-search-ui';

const namespacesCriterion: Criterion = {
  key: 'namespaces',
};

const labelsCriterion: Criterion<WorkloadFilterLabelValue[]> = {
  key: 'labels',
};

export const makeWorkloadsGpuUtilizationSearchCriteria = ({
  names = [],
  types = [],
}: {
  names?: string[];
  types?: string[];
}) => [
  ...makeSearchBoxCriteria(
    {
      title: 'Workload name:',
      key: 'workloadNames',
      allowMultiple: true,
      options: names,
    },
    {
      title: 'Workload type:',
      key: 'workloadTypes',
      allowMultiple: true,
      options: types,
    }
  ),
  namespacesCriterion,
  labelsCriterion,
];
